import React from 'react'
import { motion } from 'framer-motion'
import HeroSection from './pages/HeroSection'
import AboutSection from './pages/AboutSection'
import SkillsSection from './pages/SkillsSection'
import ExperienceSection from './pages/ExperienceSection'
import ProjectsSection from './pages/ProjectsSection'
import EducationSection from './pages/EducationSection'
import ContactSection from './pages/ContactSection'
import DockNavigation from './components/DockNavigation'
import { ShootingStars } from './components/ui/shooting-stars'

const App = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 overflow-x-hidden">
      {/* Background with shooting stars */}
      <div className="fixed inset-0 z-0">
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-transparent via-transparent to-black/20"></div>
        
        {/* Static star background */}
        <div className="absolute inset-0 opacity-30">
          <div className="absolute inset-0 bg-[radial-gradient(2px_2px_at_20px_30px,#fff,transparent),radial-gradient(2px_2px_at_40px_70px,#fff,transparent),radial-gradient(2px_2px_at_50px_160px,#fff,transparent),radial-gradient(2px_2px_at_90px_40px,#fff,transparent),radial-gradient(2px_2px_at_130px_80px,#fff,transparent),radial-gradient(2px_2px_at_160px_120px,#fff,transparent)]" style={{ backgroundRepeat: 'repeat', backgroundSize: '200px 200px' }}></div>
        </div>
        
        {/* Shooting stars with different colors and speeds */}
        <ShootingStars
          starColor="#9E00FF"
          trailColor="#2EB9DF"
          minSpeed={15}
          maxSpeed={35}
          minDelay={1000}
          maxDelay={3000}
        />
        <ShootingStars
          starColor="#FF0099"
          trailColor="#FFB800"
          minSpeed={10}
          maxSpeed={25}
          minDelay={2000}
          maxDelay={4000}
        />
        <ShootingStars
          starColor="#00FF9E"
          trailColor="#00B8FF"
          minSpeed={20}
          maxSpeed={40}
          minDelay={1500}
          maxDelay={3500}
        />
      </div>

      {/* Hero section - Fixed sidebar on desktop, regular section on mobile */}
      <HeroSection />

      {/* Main content - Adjusted for sidebar on desktop only */}
      <div className="relative z-10 md:ml-96 ml-0">
        <AboutSection />
        <SkillsSection />
        <ExperienceSection />
        <ProjectsSection />
        <EducationSection />
        <ContactSection />
      </div>

      {/* Dock navigation */}
      <DockNavigation />
    </div>
  )
}

export default App